import I18n from 'I18n';
import 'I18n/init/data/allTimezones';
import TimezoneBlacklist from 'timezone-utils/lists/TimezoneBlacklist';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
// Creates the select options text based on passed timezone
// Examples:
//   "America/New_York" --> "New York (UTC -4:00)"
//   "America/Argentina/Buenos_Aires" --> "Argentina - Buenos Aires (UTC -3:00)"
export const getDisplayNameOld = tz => {
  const tzSplit = tz.split('/');
  let timezone = tzSplit[0]; // use area name as fallback content (ex. "America")

  const locationName = (tzSplit[1] || '').toLowerCase();
  const locationNameKey = `timezone_utils.cities.${locationName}`;
  const subLocationName = (tzSplit[2] || '').toLowerCase();
  const subLocationNameKey = `timezone_utils.cities.${subLocationName}`;
  const subLocationContent = isValidI18nKey(subLocationNameKey) ? ` - ${I18n.text(subLocationNameKey)}` : '';

  // This will only be false if content is removed from
  // timezone-utils/lang or a new timezone is introduced
  if (isValidI18nKey(locationNameKey)) {
    timezone = `${I18n.text(locationNameKey)}${subLocationContent}`;
  }
  return I18n.text('timezone_utils.utc_plus_minus', {
    offset: I18n.moment.tz(tz).format('Z'),
    timezone
  });
};

// Returns a map of timezone regions/areas to locations, minus certain timezones.
// moment.tz uses IANA timezone database (https://en.wikipedia.org/wiki/List_of_tz_database_time_zones)
// Example:
//   US: ["US/Central","US/East-Indiana","US/Eastern","US/Michigan","US/Mountain","US/Pacific"]
const getTimezonesByZoneRegion = () => I18n.moment.tz.names().filter(name => name.search(/GMT/g) < 0 &&
// No GMT
name.search(/Etc/g) < 0 &&
// No Etc
name.search(/\//g) > -1 &&
// Must have a slash
!TimezoneBlacklist.includes(name) // Not in blacklist
).reduce((byZoneRegion, name) => {
  const zoneRegion = name.split('/')[0];
  if (!byZoneRegion[zoneRegion]) byZoneRegion[zoneRegion] = [];
  byZoneRegion[zoneRegion].push(name);
  return byZoneRegion;
}, {});
export const getTimezoneGroupSelectOptions = () => {
  const timezonesByZoneRegion = getTimezonesByZoneRegion();
  return Object.keys(timezonesByZoneRegion).map(region => {
    return {
      text: I18n.text(`timezone_utils.regions.${region.toLowerCase()}`),
      value: region,
      options: timezonesByZoneRegion[region].map(zoneName => {
        // timezone lib spells it differently
        if (zoneName === 'Europe/Kiev') {
          return {
            text: getDisplayNameOld(zoneName),
            value: 'Europe/Kyiv'
          };
        }
        return {
          text: getDisplayNameOld(zoneName),
          value: zoneName
        };
      }).filter(option => {
        return option.text !== '';
      })
    };
  });
};

/**
 * Returns the timezone of the device, which is generally
 * different from the account or user object timezone
 */
export function getDeviceTimezone() {
  let timezone = null;
  try {
    timezone = I18n.moment.userTz().tz() || I18n.moment.tz.guess() || Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    console.error(e);
  }
  return timezone;
}